const DIRECTORY_INITIAL_STATE = {
  sections: [],
};

export default DIRECTORY_INITIAL_STATE;
